import { createUseStyles } from "react-jss";
import { colors } from "../../constants/colors";

const styles = createUseStyles(() => ({
  promotionsPageHeader: {
    padding: "0 0 24px 0px",
  },
  title: {
    color: colors.lightBlack,
    fontWeight: "600",
    fontSize: "30px",
    lineHeight: "38px",
    padding: "0 0 0 12px",
    margin: "0px 0px 4px 0px",
  },
  description: {
    color: colors.mediumGrey,
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "24px",
    padding: "0 0 0 12px",
    margin: "0px",
  },
  container: {
    margin: 0,
    padding: 0,
    maxWidth: "100%",
  },
}));

export default styles;
